import { FilteringHashed, FilteringItem, Filters } from '@3ddv/ngx-sites-builder-lib';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectorRef,
  AfterViewInit,
} from '@angular/core';
import { IDropdownSettings, MultiSelectComponent } from 'ng-multiselect-dropdown';
import { FilteringNewItem } from '../../models/filtering.model';
import { FiltersService } from '../../services/filters.service';
import { SblibService } from '../../../../services/sblib.service';
import { ToastrService } from 'ngx-toastr';
import { CustomOpts, NodesSelectionOnGenerateFiltering } from '../../models/filtersUtils.model';

@Component({
  selector: 'app-filter-create-edit',
  templateUrl: './filter-create-edit.component.html',
  styleUrls: ['./filter-create-edit.component.scss'],
})
export class FilterCreateEditComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() tool: Filters;
  @Input() mode: 'create' | 'edit';
  @Input() filteringItems: {
    new: FilteringNewItem;
    edit: FilteringItem;
  };
  @Output() savedItem = new EventEmitter<FilteringItem>();
  @Output() cancelItem = new EventEmitter<null>();

  @ViewChild('multiselect', { static: false }) multiselectComponent: MultiSelectComponent;

  public itemList: Array<FilteringItem>;
  public itemListHashed: FilteringHashed = {};

  public customOpts: CustomOpts = {
    map: { disable: { tab: false } },
    ids: {
      disable: { tab: false, list: false },
      placeholder: {
        mapid: 'Map ID',
      },
    },
  };
  public placeholderAssociateSectSeats = 'Map ID';

  public confirmDelete: boolean = false;
  public originaEditName: string = '';
  public nodesSelection: NodesSelectionOnGenerateFiltering = {
    type: 'filter',
    pairup: false,
    manually: {
      active: false,
      mapselection: true,
      subscriptions: [],
    },
    ids: {
      active: true,
      areaprice: '',
      section: '',
      row: '',
      seat: '',
    },
    nodes: {
      //areaprice: [],
      section: [],
      row: [],
      seat: [],
    },
  };

  public menuViewer360: boolean = false;
  public current_wid: number = null;
  // Dropdown
  public dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };
  public dropdownData: Array<{ id: string; name: string }> = [];
  public dropdownSelected;

  constructor(
    private filtersService: FiltersService,
    private sblibService: SblibService,
    private toastrService: ToastrService,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.itemList = JSON.parse(JSON.stringify(this.tool.data));
    this.itemListHashed = JSON.parse(JSON.stringify(this.tool.hashed));
    this.current_wid = this.sblibService.sblib.loadOptions.siteConfiguration.mapConfig.workflow_id;
    if (this.current_wid === 6) {
      //view360
      this.switchFilteringInterface('view360');
    }
    this.dropdownData = this.generateDropdownData(this.itemList);
    
    // console.log('Filtering Items: ', this.filteringItems);
    // console.log('Nodes Selection: ', this.nodesSelection);
    if (this.filteringItems.edit) {
      this.filteringItems.edit.venueid = this.sblibService.sblib.loadOptions.siteConfiguration.mapConfig.venue_id;
      // Seguro frente a posibles sites antiguos dónde, incluso aunque tengan sectores asociados, no está seteado el mode de asociación
      if (!this.filteringItems.edit.mode) {
        // console.log('NodesSelection Type: ', this.nodesSelection.type);
        this.nodesSelection.type ? this.filteringItems.edit.mode = this.nodesSelection.type : this.filteringItems.edit.mode = 'filter';
      }
      // Se llena el objeto de nodesSelection con la info que viene de filteringItems.edit
      this.loadNodesSelectionFromEditItem();
      this.switchFilteringInterface(this.filteringItems.edit.mode);
    }
  }

  ngAfterViewInit(): void {
    this.detectPairup();
  }

  private detectPairup() {
    // console.log('Filtering items edit (Detect Pairup): ', this.filteringItems.edit);
    if (this.filteringItems.edit) {
      if (
        this.filteringItems.edit.mode === 'view360' &&
        this.filteringItems.edit.mapid &&
        this.filteringItems.edit.venueid
      ) {
        this.nodesSelection.pairup = true;
      }
      if (
        // todo 
        this.filteringItems.edit.mode === 'filter' &&
        (this.filteringItems.edit.nodes.section.length ||
          this.filteringItems.edit.nodes.row.length ||
          this.filteringItems.edit.nodes.seat.length)
      ) {
        this.nodesSelection.pairup = true;
      }
      this.changeDetector.detectChanges();
    }
    // console.log('NodeSeletcion Pairup: ', this.nodesSelection.pairup);
  }

  public switchFilteringInterface(value?) {
    if (!value) return;

    // console.log('Associate Mode switch: ', value);
    this.nodesSelection.type = value;
    if (this.nodesSelection.type === 'filter') {
      this.customOpts.ids.disable.tab = false;
      this.customOpts.ids.disable.list = false;
      this.customOpts.ids.placeholder.mapid = 'Map ID';
      this.customOpts.map.disable.tab = false;
      this.customOpts.map.disable.tab = false;
    } else if (this.nodesSelection.type === 'view360') {
      this.customOpts.ids.disable.tab = false;
      this.customOpts.ids.disable.list = true;
      this.customOpts.ids.placeholder.mapid = 'Seat ID';
      this.customOpts.map.disable.tab = true;
      this.customOpts.map.disable.tab = true;
    }
    this.changeDetector.detectChanges();
  }

  private loadNodesSelectionFromEditItem() {
    if (this.filteringItems.edit) {
      this.originaEditName = this.filteringItems.edit.name;
      // remove
      this.dropdownData = this.dropdownData.filter(i => i.id !== this.filteringItems.edit.id);
      // remove current from edit
      let childrens = this.filtersService.recursiveGetChildrenIds(this.filteringItems.edit.id, this.itemList, []);
      this.dropdownData = this.dropdownData.filter(i => childrens.indexOf(i.id) === -1);

      this.nodesSelection.nodes = this.filteringItems.edit.nodes;
      this.nodesSelection.type = this.filteringItems.edit.mode;

      if (this.nodesSelection.type === 'filter') {
        let nodestoselect = this.filteringItems.edit.nodes.section
          .concat(this.filteringItems.edit.nodes.row)
          .concat(this.filteringItems.edit.nodes.seat);
        this.sblibService.sblib.unselectAll();
        this.sblibService.sblib.select(nodestoselect);
      }
      // se borra porque se añadirá a la hashlist
      if (this.filteringItems.edit.children) delete this.filteringItems.edit.children;

      if (this.filteringItems.edit.parentId) {
        this.dropdownSelected = this.dropdownData.filter(i => i.id === this.filteringItems.edit.parentId);
      } else {
        this.dropdownSelected = [];
      }
      // console.log('nodesSelection: ', this.nodesSelection);
      // console.log('filteringItems: ', this.filteringItems);
    }
    this.activeSelectionByIds();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.itemList = JSON.parse(JSON.stringify(this.tool.data));
    this.itemListHashed = JSON.parse(JSON.stringify(this.tool.hashed));
    this.dropdownData = this.generateDropdownData(this.itemList);
  }

  private generateDropdownData(list: Array<FilteringItem>, result?: Array<{ name: string; id: string }>) {
    if (!result || !result.length) result = [];

    for (let i = 0; i < list.length; i++) {
      const item = {
        name: list[i].name,
        id: list[i].id,
      };
      result.push(item);
      if (list[i].children && list[i].children.length) {
        this.generateDropdownData(list[i].children, result);
      }
    }
    return result;
  }

  private recursiveFindAndAdd(itemToAdd, parent, itemList) {
    for (let i = 0; i < itemList.length; i++) {
      let item = itemList[i];
      if (item.id === parent.id) {
        if (!item.children) item.children = [];
        item.children.push(itemToAdd);
      }
      this.recursiveFindAndAdd(itemToAdd, parent, item.children);
    }
    return itemList;
  }

  public cancelandclose() {
    this.mode = 'create';
    this.filteringItems.new.name = '';
    if (this.filteringItems.edit) {
      this.loadNodesSelectionFromEditItem();
    }
    /*     this.filteringItems.edit = null;
    this.nodesSelection.ids.areaprice = '';
    this.nodesSelection.ids.section = '';
    this.nodesSelection.ids.row = '';
    this.nodesSelection.ids.seat = '';
    this.nodesSelection.nodes.section = [];
    this.nodesSelection.nodes.row = [];
    this.nodesSelection.nodes.seat = [];
    this.dropdownData = this.generateDropdownData(this.itemList); */
    this.sblibService.sblib.unselectAll();
    this.cancelSectionsManually();
    this.cancelItem.emit();
  }

  public cancelSectionsManually() {
    this.sblibService.sblib.runonclick();
    this.nodesSelection.manually.active = false;
    this.nodesSelection.manually.mapselection = false;
  }

  public activeSelectionByMap() {
    this.nodesSelection.manually.active = true;
    this.nodesSelection.ids.active = false;

    this.enableStopAndClick();
  }

  private enableStopAndClick() {
    this.nodesSelection.manually.mapselection = true;
    this.nodesSelection.manually.subscriptions.forEach(o => o.unsubscribe());

    const sblibReady$ = this.sblibService.getSblibReady$().subscribe(libReady => {
      // Check if viewer is ready
      const viewerReady$ = this.sblibService.sblib?.viewerIsReady$().subscribe(viewerReady => {
        const stopandclick$ = this.sblibService.sblib.stopandclick$().subscribe(res => {
          if (res.event.nodes.length) {
            let node = res.event.nodes[0];
            let exists_position = this.nodesSelection.nodes[node.type].indexOf(node.id);
            if (exists_position === -1) {
              if (res.event.instance.getMapId() !== node.id) {
                res.event.instance.select(node);
                this.nodesSelection.nodes[node.type].push(node.id);
              }
            } else {
              this.nodesSelection.nodes[node.type].splice(exists_position, 1);
              res.event.instance.unselect(node);
            }
            this.nodesSelection.nodes = JSON.parse(JSON.stringify(this.nodesSelection.nodes));
          }
        });
        this.nodesSelection.manually.subscriptions.push(stopandclick$);
      });
      this.nodesSelection.manually.subscriptions.push(viewerReady$);
    });
    this.nodesSelection.manually.subscriptions.push(sblibReady$);
  }

  public toggleMapSelection() {
    this.nodesSelection.manually.mapselection = !this.nodesSelection.manually.mapselection;
    //this.nodesSelection.manually.subscriptions.forEach(o=>o.unsubscribe());

    if (this.nodesSelection.manually.mapselection) {
      this.enableStopAndClick();
    } else {
      this.sblibService.sblib.runonclick();
      this.nodesSelection.manually.mapselection = false;
    }
  }

  public activeSelectionByIds() {
    this.cancelSectionsManually();
    this.nodesSelection.ids.active = true;
    this.nodesSelection.manually.active = false;
    /*     if(this.nodesSelection.nodes.areaprice.length){
      let raw = this.filtersService.parseArrayToString(this.nodesSelection.nodes.areaprice)
      this.nodesSelection.ids.areaprice+=raw;
    } */
    if (this.nodesSelection.nodes.section.length) {
      let raw = this.filtersService.parseArrayToString(this.nodesSelection.nodes.section);
      this.nodesSelection.ids.section = raw;
    }
    if (this.nodesSelection.nodes.row.length) {
      let raw = this.filtersService.parseArrayToString(this.nodesSelection.nodes.row);
      this.nodesSelection.ids.row = raw;
    }
    if (this.nodesSelection.nodes.seat.length) {
      let raw = this.filtersService.parseArrayToString(this.nodesSelection.nodes.seat);
      this.nodesSelection.ids.seat = raw;
    }
  }

  public parseTextareaSection() {
    this.nodesSelection.nodes.section = this.filtersService.parseTextareaToArray(this.nodesSelection.ids.section);
    this.nodesSelection.nodes = JSON.parse(JSON.stringify(this.nodesSelection.nodes));
  }

  public parseTextareaRow() {
    this.nodesSelection.nodes.row = this.filtersService.parseTextareaToArray(this.nodesSelection.ids.row);
    this.nodesSelection.nodes = JSON.parse(JSON.stringify(this.nodesSelection.nodes));
  }

  public parseTextareaSeat() {
    this.nodesSelection.nodes.seat = this.filtersService.parseTextareaToArray(this.nodesSelection.ids.seat);
    this.nodesSelection.nodes = JSON.parse(JSON.stringify(this.nodesSelection.nodes));
  }

  public addNew() {
    // Create new
    let filteringItem = this.filtersService.createNewItemParent();
    filteringItem.name = this.filteringItems.new.name;
    filteringItem.type = this.filteringItems.new.type;
    filteringItem.color = this.filteringItems.new.color;
    if (this.dropdownSelected && this.dropdownSelected.length && this.dropdownSelected[0].id) {
      filteringItem.parentId = this.dropdownSelected[0].id;
      this.itemList = this.recursiveFindAndAdd(filteringItem, this.dropdownSelected[0], this.itemList);
    } else {
      this.itemList.push(filteringItem);
    }
    this.itemListHashed[filteringItem.id] = filteringItem;
    // Refresh Dropdown
    this.dropdownData = this.dropdownData.concat({
      id: filteringItem.id,
      name: filteringItem.name,
    });
    this.multiselectComponent.placeholder = 'Seleccionar elemento (' + this.dropdownData.length + ')';
    this.filteringItems.new.name = '';
    this.filteringItems.new.type = 'vip';
    this.filteringItems.new.color = '';
    this.filtersService.setListAndHash$({
      data: this.itemList,
      hash: this.itemListHashed,
    });
    this.savedItem.emit(filteringItem);
  }

  public saveEditItem() {
    if (this.dropdownSelected && this.dropdownSelected.length && this.dropdownSelected[0].id) {
      this.filteringItems.edit.parentId = this.dropdownSelected[0].id;
    } else {
      this.filteringItems.edit.parentId = '';
    }

    // Mode is set on init (bc old sites weren't showing their associated sections, without filteringItems.edit.mode set on 'filter')
    // But type could be modified, so save on filter's mode
    this.nodesSelection.type ? this.filteringItems.edit.mode = this.nodesSelection.type : this.filteringItems.edit.mode = 'filter';

    // if (!this.filteringItems.edit.mode) this.filteringItems.edit.mode = 'filter';

    this.filteringItems.edit.nodes = JSON.parse(JSON.stringify(this.nodesSelection.nodes));
    this.itemListHashed[this.filteringItems.edit.id] = JSON.parse(JSON.stringify(this.filteringItems.edit));
    // Regenerate item list
    this.itemList = this.filtersService.parseHashToList(this.itemListHashed, JSON.parse(JSON.stringify(this.itemList)));

    // Clone ItemToUpdate
    let itemToUpdate = JSON.parse(JSON.stringify(this.filteringItems.edit)) as FilteringItem;

    if (!itemToUpdate.children) itemToUpdate.children = [];

    // UPDATE LIST TO OBSERVABLE
    this.filtersService.setListAndHash$({
      data: this.itemList,
      hash: this.itemListHashed,
    });
    this.sblibService.sblib.unselectAll();
    this.cancelSectionsManually();
    this.toastrService.success('Saved. Please confirm when finish.');
    this.savedItem.emit(this.filteringItems.edit);
  }

  public deleteEditItem() {
    delete this.itemListHashed[this.filteringItems.edit.id];
    this.itemList = this.filtersService.recursiveDeleteChildren(this.filteringItems.edit, this.itemList);
    this.itemListHashed = this.filtersService.parseListToHash(this.itemList, {});
    const refreshedDropDown = this.generateDropdownData(this.itemList);
    this.dropdownData = refreshedDropDown.filter(i => i.id !== this.filteringItems.edit.id);
    this.filteringItems.edit = null;
    this.filteringItems.new.name = '';
    this.dropdownSelected = {};
    // UPDATE LIST TO OBSERVABLE
    this.filtersService.setListAndHash$({
      data: this.itemList,
      hash: this.itemListHashed,
    });
    this.confirmDelete = false;
    this.cancelItem.emit();
  }
}
